export default __webpack_public_path__ + "static/media/MIKA_logo-01.7775ae9b.svg";